import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { TenantContextService } from 'app/core/services/tenant-context.service';

/**
 * App-level 404 for unrecognized `*.photoflow.vn` hostnames. The cluster
 * ingress wildcard-matches every such host to this app, so without this
 * guard an unrecognized host fell through to the full app shell with a 200.
 *
 * `TenantContextService.mode === 'unknown'` covers any host that isn't
 * `localhost`, the root domain, or a single-label subdomain (reserved infra
 * labels like app/api/iam classify as `'root'`, unaffected).
 *
 * Wired as `canMatch` first in `appRoutes`. The `errors` segment is always
 * let through: it's this guard's own redirect target, and gating it too
 * would infinite-loop.
 */
export const unknownHostGuard: CanMatchFn = (_route, segments) => {
    if (segments[0]?.path === 'errors') {
        return false;
    }

    const tenantContext = inject(TenantContextService);
    if (tenantContext.mode !== 'unknown') {
        return false;
    }

    const router = inject(Router);
    return router.createUrlTree(['/errors/not-found']);
};
